import { Button, Form, Input, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { signin } from "../../actions/auth";
import { LockOutlined, MailOutlined } from "@ant-design/icons";

const Login = () => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const [form] = Form.useForm();
  const [, forceUpdate] = useState({});
  const [testShow, setTestShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const onFinish = (formData) => {
    setLoading(true);
    dispatch(signin(formData, history, setLoading));
  };
  const { Paragraph } = Typography;

  useEffect(() => {
    setLoading(false);
    setTestShow(false);
    forceUpdate({});
  }, []);
  console.log("testShow", testShow);
  return (
    <div className="w-screen h-screen flex flex-col justify-center items-center bg-gray-100 relative overflow-hidden">
      <Form
        form={form}
        name="basic"
        style={{ width: 300 }}
        onFinish={onFinish}
        requiredMark={false}
        layout="vertical"
        autoComplete="off"
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: "Please input your username!" }]}
        >
          <Input prefix={<MailOutlined />} placeholder="Email" />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password prefix={<LockOutlined />} placeholder="Password" />
        </Form.Item>

        <Form.Item shouldUpdate>
          {() => (
            <Button
              type="primary"
              htmlType="submit"
              disabled={
                !form.isFieldsTouched(true) ||
                !!form.getFieldsError().filter(({ errors }) => errors.length)
                  .length
              }
              loading={loading}
            >
              Log in
            </Button>
          )}
        </Form.Item>
      </Form>
      <p>Want to create new store?</p>
      <Button type="primary" href="/register">
        Create Store
      </Button>

      <div className="absolute bottom-0 right-0 w-72 p-2">
        {testShow ? (
          <div className="border p-2">
            <p className="flex gap-1">
              Email:
              <Paragraph copyable style={{ marginBottom: 0 }}>
                jatinder.kaur@kochartech.com
              </Paragraph>
            </p>
            <p className="flex gap-1">
              Password:
              <Paragraph copyable style={{ marginBottom: 0 }}>
                123456
              </Paragraph>
            </p>
          </div>
        ) : (
          ""
        )}
        <p
          onClick={() => setTestShow(testShow === true ? false : true)}
          className="border text-center"
        >
          Test credentials
        </p>
      </div>
    </div>
  );
};

export default Login;
